import { render } from "./DomainDialog.vue?vue&type=template&id=556b5696&ts=true"
import script from "./DomainDialog.vue?vue&type=script&lang=ts"
export * from "./DomainDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__